import { createRoute, lazyRouteComponent, redirect, type AnyRoute } from "@tanstack/react-router";
import { z } from "zod";
import { fetchMe, meQueryKey } from "@/lib/session.tsx";

const listSearch = z.object({
  page: z.coerce.number().int().min(1).optional(),
  pageSize: z.coerce.number().int().min(10).max(200).optional(),
  q: z.string().optional(),
  status: z.string().optional(),
  operatorId: z.coerce.number().optional(),
  tab: z.string().optional(),
}).passthrough();

export function platformRoutes(parent: AnyRoute): AnyRoute[] {
  const layout = createRoute({
    getParentRoute: () => parent,
    path: "/platform",
    beforeLoad: async ({ context }) => {
      const me = await context.queryClient.ensureQueryData({ queryKey: meQueryKey, queryFn: fetchMe });
      if (me?.role !== "platform_admin") throw redirect({ to: "/" });
    },
    component: lazyRouteComponent(() => import("./pages/layout.tsx")),
  });
  const r = (path: string, load: () => Promise<{ default: React.ComponentType }>, search = true) =>
    createRoute({ getParentRoute: () => layout, path, component: lazyRouteComponent(load), ...(search ? { validateSearch: (s: Record<string, unknown>) => listSearch.parse(s) } : {}) });

  layout.addChildren([
    r("/", () => import("./pages/overview.tsx"), false),
    r("/operators", () => import("./pages/operators.tsx")),
    r("/operators/new", () => import("./pages/operator-new.tsx"), false),
    r("/operators/$id", () => import("./pages/operator-detail.tsx")),
    r("/plans", () => import("./pages/plans.tsx")),
    r("/tools", () => import("./pages/tools.tsx")),
    r("/catalogue", () => import("./pages/catalogue-review.tsx")),
    r("/queues", () => import("./pages/queues.tsx")),
    r("/audit", () => import("./pages/audit.tsx")),
    r("/usage", () => import("./pages/usage.tsx")),
    r("/runbooks", () => import("./pages/runbooks.tsx"), false),
    r("/enquiries", () => import("./pages/enquiries.tsx")),
  ]);
  return [layout];
}
